/*
 *  Accordion
 *    Styles for controlling accordions.
 *    Will init on all [data-accordion]'s by default, but can be supered as well
 *
 *  Version:
 *    1.0.1 - 2018/07/08
 */
import $ from 'jquery';

export const SLIDE_SELECTOR = '[data-accordion-slide]';
export const TITLE_SELECTOR = '[data-accordion-title]';
export const BODY_SELECTOR = '[data-accordion-body]';

export const EXPANDED_CLASS = 'is-expanded';

export class Accordion {
  constructor(container) {
    this.container = container;

    //Settings
    this.allowMultiple = container.attr('data-multiple') == "true" ? true : false;

    //Setup data attributes
    let slides = container.find(SLIDE_SELECTOR);
    slides.each((i, e) => {
      this.setSlideIndex($(e), i);
    });

    //Event listeners
    container.on('click', TITLE_SELECTOR, e => this.onTitleClick(e));
  }

  setSlideIndex(slide, index) {
    //Does this node already have an index?
    let existingIndex = slide.attr('data-index');
    if(existingIndex) return;//Yes, don't do anything

    //If there's no index supplied, find an available one.
    if(typeof index === typeof undefined) {
      let i = 0;
      while(true) {
        //Is this index taken by another slide?
        let existing = this.container.find(`${SLIDE_SELECTOR}[data-index="${i}"]`);
        if(existing.length) { i++; continue; }//Taken
        index = `${i}`;
        break;
      }
    }

    //Setup indexes
    slide.attr('data-index', index);
    slide.find(`${TITLE_SELECTOR},${BODY_SELECTOR}`).attr('data-index', index);
  }

  getSlide(index) {
    //Find slide by index
    return this.container.find(`${SLIDE_SELECTOR}[data-index="${index}"]`);
  }

  useSlide(index) {
    //Get slide
    let slide = this.getSlide(index);
    let slideBody = slide.find(BODY_SELECTOR);
    let slideBodies = this.container.find(BODY_SELECTOR);

    //If Multiple just toggle
    if(this.allowMultiple) return slide.toggleClass(EXPANDED_CLASS);

    //Not multple, is currently open?
    let close = slide.hasClass(EXPANDED_CLASS);
    this.container.find(SLIDE_SELECTOR).removeClass(EXPANDED_CLASS);//Close all
    slideBodies.slideUp(200);
    if(close) return;//If was open, leave closed

    //Was not opened before, open now.
    slide.addClass(EXPANDED_CLASS);
    slideBody.slideDown(200);
  }

  onTitleClick(e) {

    //Get Element
    let self = $(e.currentTarget);
    let slideContainer = self.parent(SLIDE_SELECTOR);
    this.setSlideIndex(slideContainer);

    let index = parseInt(self.attr('data-index'));//Get Index
    if(isNaN(index)) return;//Has index?

    //Set Slide
    this.useSlide(index);
  }
}
